import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid";


export const SessionsCustomToolbar = (checked, handleChangeChecked, showDeleted, setShowDeleted, isDev) => {
    return (
        <GridToolbarContainer>
            <GridToolbarFilterButton />
            <Box sx={{ flexGrow: 1 }} />
            <FormControlLabel control={<Checkbox checked={checked} onChange={handleChangeChecked} />} label="Visa test-sessioner" />
            {isDev === true ? (
                <FormControlLabel control={<Checkbox checked={showDeleted} onChange={setShowDeleted} />} label="Visa borttagna sessioner" />
            ) : ("")}
            <GridToolbarQuickFilter />
        </GridToolbarContainer>
    );
}